import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { Carousel, useCarouselScroll } from '@/components';
import { CAROUSEL_EPISODES_LIMIT } from '@/constants';
import {
  EpisodeCard,
  EpisodeCardDimensions,
  EpisodeCardGutterSpacing,
  EpisodeCardPlaceholder,
  EpisodeCardVariants,
} from '@/containers';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectSessionUserId,
  selectUserCompliance,
  useFetchOrganizationPlaylistEpisodesQuery,
} from '@/store';

import { SelectedEpisodesToolbar } from '../SelectedEpisodesToolbar';

const variant = EpisodeCardVariants.MEDIUM;
const title = 'Your Picks';
const itemsPerScroll = 2;
const uKey = 'Org Playlist Admin Preview';
const referrer = {
  page: EVENT_CONSTANTS.PAGE.CONTENT_CURATION,
};

export const OrgPlaylistPreviewCarousel = () => {
  const compliance = useSelector(selectUserCompliance);
  const userId = useSelector(selectSessionUserId);

  const {
    data: episodes = [],
    isLoading,
    isUninitialized,
    isError,
  } = useFetchOrganizationPlaylistEpisodesQuery(
    { compliance },
    { skip: !userId },
  );

  const episodeList =
    episodes.length === 0
      ? Array.from<undefined>({ length: CAROUSEL_EPISODES_LIMIT })
      : episodes;

  const itemWidth =
    EpisodeCardDimensions[variant].width +
    EpisodeCardGutterSpacing[variant] * 8;
  const { containerId, scroll, isNearBeginning, isNearEnd } = useCarouselScroll(
    {
      itemWidth: itemsPerScroll * itemWidth,
      uKey,
      referrer,
    },
  );

  if (isUninitialized || isError) return;

  return (
    <Carousel
      title={title}
      leftScrollIcon={!isNearBeginning}
      rightScrollIcon={!isNearEnd}
      containerId={containerId}
      scroll={scroll}>
      {episodeList.map((episode, index) => (
        <Box
          key={`${uKey}-${index}-${episode?.episodeId}`}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            mr: EpisodeCardGutterSpacing[variant],
          }}>
          {episodes.length > 0 ? (
            <Box sx={{ flex: 1 }}>
              <EpisodeCard
                variant={variant}
                episode={episode}
                referrer={{
                  ...referrer,
                  carousel: uKey,
                  position: index + 1,
                }}
                isLoading={isLoading}
              />
            </Box>
          ) : (
            <EpisodeCardPlaceholder />
          )}
          {episode && (
            <Box>
              <SelectedEpisodesToolbar episodeId={episode.episodeId} />
            </Box>
          )}
        </Box>
      ))}
    </Carousel>
  );
};
